module.exports = __webpack_public_path__ + "img/mmi-profile-anonymous.c3352360.png";